import { CameraAlt, Delete } from "@mui/icons-material";
import { useState } from "react";
import html2canvas from "html2canvas";
import { Button, Box, Typography, IconButton, useTheme } from "@mui/material";

export function ScreenshotButton({ onScreenshotTaken, screenshot, isShowButton = false }) {
  const [isTakingScreenshot, setIsTakingScreenshot] = useState(false);
  const theme = useTheme();

  async function handleTakeScreenshot() {
    setIsTakingScreenshot(true);
    const canvas = await html2canvas(document.querySelector("html"));
    const base64image = canvas.toDataURL("image/png");
    onScreenshotTaken(base64image);
    setIsTakingScreenshot(false);
  }

  if (screenshot) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box
          component="img"
          src={screenshot}
          sx={{
            width: 60,
            height: 40,
            borderRadius: 2,
            border: `2px solid ${theme.palette.primary.main}`,
            objectFit: "cover"
          }}
        />
        <IconButton 
          size="small" 
          onClick={() => onScreenshotTaken(null)}
          sx={{ color: theme.palette.error.main }}
        >
          <Delete fontSize="small" />
        </IconButton>
      </Box>
    );
  }

  return (
    <Button
      variant="outlined"
      size="small"
      onClick={handleTakeScreenshot}
      disabled={isTakingScreenshot}
      startIcon={<CameraAlt />}
      sx={{ borderRadius: 2 }}
    >
      {isTakingScreenshot ? "Capturando..." : "Capturar tela"}
    </Button>
  );
}